import React, { useEffect, useRef } from "react";
import { useField } from "@unform/core";

export default function Radio({ name, options, onChange, radioclass }) {
  const inputRefs = useRef([]);
  const { fieldName, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      path: "value",
      ref: inputRefs.current,
      getValue(refs) {
        const checked = refs.find((ref) => ref.checked);
        return checked ? checked.value : undefined;
      },
      setValue(refs, value) {
        const item = refs.find((ref) => ref.value === value);
        if (item) {
          item.checked = true;
        }
      },
    });
  }, [fieldName, registerField]);

  return (
    <>
      {options.map((option, index) => (
        <React.Fragment key={option.id}>
          <div className="form-check">
            <input
              ref={(elRef) => (inputRefs.current[index] = elRef)}
              type="radio"
              className="form-check-input"
              onChange={(e) => {
                if (onChange) onChange(e.target.value);
              }}
              name={fieldName}
              id={option.id}
              value={option.id}
              defaultChecked={options[0].id === option.id}
            />
            <label className="form-check-label" htmlFor={option.id}>
            {option.icon} {option.label}
            </label>
          </div>
        </React.Fragment>
      ))}
      {error && (
        <>
          <span className="text-danger mt-2 shake-horizontal">{error}</span>
        </>
      )}
    </>
  );
}
